<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
            <div class="font-400 font-size-20px line-h-25 mt-ipad-15">
                {{ "ManageAddress" | translate }}
            </div>
            <div class="br-16 border border-color-ddd bg-base-100 box-shadow p-24 mt-40">
                <div class="font-600 font-size-14px color-base-2200 line-h-22 letter-spacing-03">
                    {{ "PrimaryAddress" | translate }}
                </div>
                <div class="font-400 font-size-14px color-base-700 line-h-22 letter-spacing-1 mt-5">
                    Lot 1, Rd 5683, Manama, Bahrain
                </div>
                <grid-row class="col-space mt-15">
                    <grid-col col="6">
                        <button class="btn-dft-border br-40 h-42"  (click)="settingEditPrimary()">
                            <ng-icon iconClass="icon-edit-green" width="20" height="20"></ng-icon>
                        </button>
                    </grid-col>
                    <grid-col col="6">
                        <button class="btn-dft-border br-40 h-42" (click)="showModal(1)">
                            <ng-icon iconClass="icon-delete-16px" width="20" height="20"></ng-icon>
                        </button>
                    </grid-col>
                </grid-row>
            </div>
            <div class="br-16 border border-color-ddd bg-base-100 box-shadow p-24 mt-16">
                <div class="font-600 font-size-14px color-base-2200 line-h-22 letter-spacing-03">
                    {{ "Home2" | translate }}
                </div>
                <div class="font-400 font-size-14px color-base-700 line-h-22 letter-spacing-1 mt-5">
                    Villa 1145A, Rd 179, Sanabis, Bahrain
                </div>
                <grid-row class="col-space mt-15">
                    <grid-col col="6">
                        <button class="btn-dft-border br-40 h-42"  (click)="settingEditPrimary()">
                            <ng-icon iconClass="icon-edit-green" width="20" height="20"></ng-icon>
                        </button>
                    </grid-col>
                    <grid-col col="6">
                        <button class="btn-dft-border br-40 h-42" (click)="showModal(1)">
                            <ng-icon iconClass="icon-delete-16px" width="20" height="20"></ng-icon>
                        </button>
                    </grid-col>
                </grid-row>
            </div>
            <div class="br-16 border border-color-ddd bg-base-100 box-shadow p-24 mt-16">
                <div class="font-600 font-size-14px color-base-2200 line-h-22 letter-spacing-03">
                    {{ "Home3" | translate }}
                </div>
                <div class="font-400 font-size-14px color-base-700 line-h-22 letter-spacing-1 mt-5">
                    Lot 147, Rd 701, Tubli, Bahrain
                </div>
                <grid-row class="col-space mt-15">
                    <grid-col col="6">
                        <button class="btn-dft-border br-40 h-42"  (click)="settingEditPrimary()">
                            <ng-icon iconClass="icon-edit-green" width="20" height="20"></ng-icon>
                        </button>
                    </grid-col>
                    <grid-col col="6">
                        <button class="btn-dft-border br-40 h-42" (click)="showModal(1)">
                            <ng-icon iconClass="icon-delete-16px" width="20" height="20"></ng-icon>
                        </button>
                    </grid-col>
                </grid-row>
            </div>
            <grid-row class="justify-content-between mt-50">
                <grid-col col="auto">
                    <button class="btn-back" (click)="back()">
                        <i class="icon-back"></i>
                    </button>
                </grid-col>
                <grid-col col="9" mobile="auto">
                    <button class="btn-dft-border">
                        {{ "ADDNEWADDRESS" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>

<!-- Remove Address -->
<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="cancel" (doneButton)="showModal(0)">
    <div class="text-align-center">
        <ng-icon iconClass="icon-remove-address" width="72" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"RemoveAddress" | translate}}
        </div>
        <div class="mt-30">
            <span class="font-400 font-size-14px line-h-22 color-base-700 letter-spacing-1">
                {{"AreWantRemove" | translate}}
            </span>
            <span class="font-600 font-size-14px line-h-22 color-base-2200 letter-spacing-1">
                {{"Home2" | translate}}
            </span>
            <span class="font-400 font-size-14px line-h-22 color-base-700 letter-spacing-1">
                {{"FromAddress" | translate}}
            </span>
        </div>
    </div>
</modal>


